<template>
  <div>
    <!--工厂信息-->
    <div class="page-Fy-form">
      <div style="flex-shrink: 0">
        <span>工厂信息&nbsp;&nbsp;&nbsp;:</span>
      </div>
      <a-form :form="forms" @submit="handleSubmit" class="page-fyFrom">
        <a-form-item label="工厂名称">
          <a-input
            placeholder="请填写工厂中文名称"
            v-decorator="[
              'factory',
              {
                rules: [
                  {
                    required: true,
                    message: '请填写工厂中文名称!',
                  },
                ],
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="所在区域">
          <a-cascader
            :options="options"
            placeholder="请选择所在区域"
            @change="onAreaFy"
            changeOnSelect
            v-decorator="[
              'factoryRegion',
              {
                rules: [
                  {
                    required: true,
                    message: '请选择所在区域!',
                  },
                ],
              },
            ]"
          />
        </a-form-item>
        <a-form-item label="工厂地址">
          <a-input
            placeholder="请填写工厂详细地址"
            v-decorator="[
              'factoryAddress',
              {
                rules: [
                  {
                    required: true,
                    message: '请填写工厂详细地址!',
                  },
                ],
              },
            ]"
          />
        </a-form-item>
        <div class="page-formFy-oneself">
          <a-form-item label="联系人姓名">
            <a-input
              placeholder="请填写联系人姓名"
              v-decorator="[
                'contactName',
                {
                  rules: [
                    {
                      required: true,
                      message: '请填写联系人姓名!',
                    },
                  ],
                },
              ]"
            />
          </a-form-item>
          <a-form-item label="固话">
            <a-input
              placeholder="请填写固定电话"
              v-decorator="[
                'fixedPhone',
                {
                  rules: [
                    {
                      required: true,
                      message: '请填写固定电话!',
                    },
                  ],
                },
              ]"
            />
          </a-form-item>
        </div>
        <div class="page-formFy-oneself">
          <a-form-item label="手机">
            <a-input
              placeholder="请填写手机号码"
              v-decorator="[
                'handset',
                {
                  rules: [
                    {
                      required: true,
                      message: '请填写手机号码!',
                    },
                  ],
                },
              ]"
            />
          </a-form-item>
          <a-form-item label="邮箱">
            <a-input
              placeholder="请填写邮箱"
              v-decorator="[
                'email',
                {
                  rules: [
                    {
                      required: true,
                      message: '请填写邮箱!',
                    },
                  ],
                },
              ]"
            />
          </a-form-item>
        </div>
      </a-form>
    </div>
    <!--===============注意事项======================-->
    <div class="page-Fy-form">
      <div style="flex-shrink: 0">
        <span>注意事项&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:</span>
      </div>
      <a-form :form="forms" @submit="handleSubmit" class="page-fyFrom-One">
        <a-form-item style="text-align: left;width: 100%">
          <div class="page-F-F">
            <div class="page-inpt-teFy">
              <a-upload
                action="//jsonplaceholder.typicode.com/posts/"
                :defaultFileList="defaultFileList"
                @change="handleChangeUpload"
              >
                <a-button> <a-icon type="upload" /> 上传附件 </a-button>
              </a-upload>
              <span style="margin: auto">
                哪些问题需要QC特别注意关注？例：重点查看弹簧片有没有生锈
              </span>
            </div>
          </div>
          <span style="color: rgba(195, 195, 195, 1);">
            尽可能详细地上传产品资料,比如产品图片、跟单信息、包装方式等。
          </span>
        </a-form-item>
      </a-form>
    </div>
    <!--==============我的信息==================-->
    <div class="page-Fy-form">
      <div style="flex-shrink: 0">
        <span>我的信息&nbsp;&nbsp;&nbsp;:</span>
      </div>
      <a-form :form="forms" @submit="handleSubmit" class="page-fyFrom">
        <a-form-item label="公司名称">
          <a-input
            placeholder="请填写公司名称"
            v-decorator="[
              'company',
              {
                rules: [
                  {
                    required: true,
                    message: '请填写公司名称!',
                  },
                ],
              },
            ]"
          />
        </a-form-item>
        <div class="page-formFy-oneself">
          <a-form-item label="联系人姓名">
            <a-input
              placeholder="请填写联系人姓名"
              v-decorator="[
                'myContactName',
                {
                  rules: [
                    {
                      required: true,
                      message: '请填写联系人姓名!',
                    },
                  ],
                },
              ]"
            />
          </a-form-item>
          <a-form-item label="固话">
            <a-input
              placeholder="请填写固定电话"
              v-decorator="[
                'myFixedPhone',
                {
                  rules: [
                    {
                      required: true,
                      message: '请填写固定电话!',
                    },
                  ],
                },
              ]"
            />
          </a-form-item>
        </div>
        <div class="page-formFy-oneself">
          <a-form-item label="手机">
            <a-input
              placeholder="请填写手机号码"
              v-decorator="[
                'myHandset',
                {
                  rules: [
                    {
                      required: true,
                      message: '请填写手机号码!',
                    },
                  ],
                },
              ]"
            />
          </a-form-item>
          <a-form-item label="邮箱">
            <a-input
              placeholder="请填写邮箱"
              v-decorator="[
                'myEmail',
                {
                  rules: [
                    {
                      required: true,
                      message: '请填写邮箱!',
                    },
                  ],
                },
              ]"
            />
          </a-form-item>
        </div>
      </a-form>
    </div>
    <!--===============验货时间======================-->
    <div class="page-Fy-form">
      <div style="flex-shrink: 0">
        <span>验货时间&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:</span>
      </div>
      <a-form
        :form="forms"
        @submit="handleSubmit"
        class="page-fyFrom-One"
        style="text-align: left"
      >
        <div>
          <a-form-item>
            <a-date-picker
              @change="onDateChange"
              placeholder="请选择日期"
              v-decorator="[
                'goodsDate',
                {
                  rules: [
                    {
                      required: true,
                      message: '请填写款号/型号!',
                    },
                  ],
                },
              ]"
            />
          </a-form-item>
        </div>
        <span style="color: rgba(195, 195, 195, 1);margin-left: 59px">
          若未能确认最终验货日期，可选择预估日期，我司质检人员将于工厂最终确认
        </span>
        <a-form-item :wrapper-col="{ span: 12, offset: 5 }">
          <div class="page-fySubmit">
            <a-button type="primary" html-type="submit">
              提交订单
            </a-button>
          </div>
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'checkMill',
  data() {
    return {
      forms: this.$form.createForm(this),
      // 联动数据
      options: [
        {
          value: 'zhejiang',
          label: 'Zhejiang',
          children: [
            {
              value: 'hangzhou',
              label: 'Hangzhou',
              children: [
                {
                  value: 'xihu',
                  label: 'West Lake',
                },
              ],
            },
          ],
        },
        {
          value: 'jiangsu',
          label: 'Jiangsu',
          children: [
            {
              value: 'nanjing',
              label: 'Nanjing',
              children: [
                {
                  value: 'zhonghuamen',
                  label: 'Zhong Hua Men',
                },
              ],
            },
          ],
        },
      ],
      // 上传附件
      defaultFileList: [
        // {
        //   uid: '2',
        //   name: 'yyy.png',
        //   status: 'done',
        //   url: 'http://www.baidu.com/yyy.png',
        // },
        // {
        //   uid: '3',
        //   name: 'zzz.png',
        //   status: 'error',
        //   response: 'Server Error 500', // custom error message to show
        //   url: 'http://www.baidu.com/zzz.png',
        // },
      ],
    };
  },
  methods: {
    /*表单提交*/
    handleSubmit(e) {
      console.log('===========', e);
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values);
        }
      });
      // this.forms.validateFields((err, values) => {
      //   if (!err) {
      //     console.log('Received values of form: ', values);
      //   }
      // });
    },
    /*上传附件*/
    handleChangeUpload({ file, fileList }) {
      if (file.status !== 'uploading') {
        console.log(file, fileList);
      }
    },
    /*所在区域联动*/
    onAreaFy(value) {
      console.log(value);
    },
    /*检验时间*/
    onDateChange(date, dateString) {
      console.log(date, dateString);
    },
  },
};
</script>

<style lang="less">
@import './css';
</style>
